export const Screen = {
  width: 3508,
  height: 2480,
};
